import { gql, useQuery } from "@apollo/client";
import { TenantsQueryQuery } from "../../../../schemaTypes";

export const tenantsQuery = gql`
  query TenantsQuery {
    tenants {
      id
      name
      slug
      status
      isDefault
    }
  }
`;

/** All tenants, for the platform admin's tenant switcher (L1/L2 only). */
export const useTenants = ({ skip = false }: { skip?: boolean } = {}) => {
  const { data, loading } = useQuery<TenantsQueryQuery>(tenantsQuery, { skip });
  return { tenants: data?.tenants ?? [], loading };
};
